"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShoppingCartProcessorUI = void 0;
const mathjs_1 = require("mathjs");
class ShoppingCartProcessorUI {
  shoppingCartProcessor;
  constructor(shoppingCartProcessor) {
    this.shoppingCartProcessor = shoppingCartProcessor;
  }
  computeCartItems() {
    return this.shoppingCartProcessor.computeCartItems();
  }
  validateItems(cartItems) {
    return this.shoppingCartProcessor.validateItems(cartItems);
  }
  process(input) {
    const result = this.shoppingCartProcessor.process(input);
    const condensed = new Map();
    const totals = {
      cancellation_cost: 0,
      other: 0,
      total: 0,
      tax: 0,
      current_order_total: 0,
      total_discount: 0,
      paid: 0
    };
    const uiResult = {
      order: this._toOrderUI(result.transactions, condensed, totals),
      currentOrder: this._toOrderUI(result.transactionsToAdd, condensed, totals),
      errors: result.errors,
      condensedItems: [],
      totals: totals,
      donationProducts: result.donationProducts
    };
    uiResult.condensedItems = [...condensed.values()].filter(e => e.quantity !== 0).map(e => {
      e.unit_price = (0, mathjs_1.round)(e.subtotal / e.quantity, 2);
      return e;
    });
    uiResult.totals.total = uiResult.currentOrder.total + uiResult.order.total;
    uiResult.totals.tax = uiResult.currentOrder.tax + uiResult.order.tax;
    uiResult.totals.paid = -1 * uiResult.order.total;
    uiResult.totals.cancellation_cost = uiResult.currentOrder.cancellationCost + uiResult.order.cancellationCost;
    uiResult.totals.current_order_total = uiResult.currentOrder.total;
    return uiResult;
  }
  setDonationPrices(donationProducts) {
    this.shoppingCartProcessor.setDonationPrices(donationProducts);
  }
  _toOrderUI(transactions, condensed, totals) {
    const order = {
      orderItems: [],
      cancellationCost: 0,
      total: 0,
      tax: 0
    };
    transactions.forEach(txn => {
      txn.items.forEach(txnItem => {
        const uiOrderItem = this._toOrderItemUI(txnItem, txn.created_at);
        order.orderItems.push(uiOrderItem);
        order.total += (0, mathjs_1.round)(txnItem.total, 2);
        order.tax += (0, mathjs_1.round)(uiOrderItem.tax, 2);
        // cancellation cost
        if (txnItem.cancellation_item_id && txnItem.product?.type === 'cancellation') {
          order.cancellationCost += txnItem.total;
        } else if (txnItem.product.id && this.shoppingCartProcessor.productExists(txnItem.product.id)) {
          let e = condensed.get(txnItem.product.id);
          if (!e) {
            e = {
              product_name: '',
              quantity: 0,
              total: 0,
              subtotal: 0,
              unit_price: 0,
              product: this.shoppingCartProcessor.getProduct(txnItem.product.id)
            };
            condensed.set(txnItem.product.id, e);
          }
          // total for products in cart.
          e.product_name = txnItem.product.name;
          e.quantity += txnItem.quantity;
          e.total += txnItem.total;
          e.subtotal += txnItem.subtotal;
          totals.total_discount += txnItem.discount;
        } else if (txnItem.product.id) {
          // total for deleted products.
          totals.other += txnItem.total;
          totals.total_discount += txnItem.discount;
        }
      });
    });
    return order;
  }
  _toOrderItemUI(ti, transactionCreatedAt) {
    return {
      transaction_date: transactionCreatedAt,
      quantity: ti.quantity,
      product_name: ti.product.name,
      unit_price: ti.product.price,
      discount: ti.discount,
      tax: ti?.tax?.percentage ? (0, mathjs_1.round)(ti.product.price * (ti?.tax?.percentage ?? 0) / 100, 2) : 0,
      total: ti.total,
      subtotal: ti.subtotal,
      id: ti.id
    };
  }
}
exports.ShoppingCartProcessorUI = ShoppingCartProcessorUI;
